module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAe0lEQVR4Ae2ZAQaAQBAA7xsBBPe3HOAAvSP0wrhHTEgEEe6wmnnBDIBJItIPYAHmqPKFiwOYo8rziMhR5W8aMEWVB9jTOJSvyiuvvPLKK6+88sor3yVg5Z0tRQCo/4owwggjjDDCCCOMMKIY4eAYF9GAHHnyZTfrJ0TkBClecT0ltHfUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Help/baseline_arrow_back_ios_white_24dp.png
// module id = 175
// module chunks = 0